import { CircularProgress, Box, Tooltip } from '@mui/material';
import aiMusicGeneratorApi from 'services/api/aiMusicGenerator';
import ErrorMessage from '../../../FormulaEditor/components/ErrorMessage';
import { ControlComponentProps } from '../../types';
import { StyledContainer, StyledToggleButton } from './styled';

type StructureSelectorProps = ControlComponentProps<number | null>;

const StructureSelector = ({ value, onChange }: StructureSelectorProps) => {
  const {
    data: structures = [],
    isLoading: loading,
    error,
  } = aiMusicGeneratorApi.useGetAiMusicGeneratorSongStructuresQuery();

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <ErrorMessage />;
  }

  return (
    <StyledContainer>
      {structures.map(({ id, name, description, imageUrl }) => (
        <Tooltip key={id} title={name} placement="right">
          <StyledToggleButton
            selected={id === value}
            value={id}
            onChange={(_, structureId) => onChange(structureId)}
          >
            <img src={imageUrl} alt={description} />
          </StyledToggleButton>
        </Tooltip>
      ))}
    </StyledContainer>
  );
};

export default StructureSelector;
